// eslint-disable-next-line import/prefer-default-export
export const amountAPISymbols = ["〇", "△", "✖", "-"] as const; // APIレスポンスで返ってくる仕入先の数量を表す記号
export const amountSymbols = ["○", "△", "×", "-"] as const; // 仕入先の数量を表す記号
export const categories = ["tyre_wheel", "general"] as const;
export const supplierHeaderColor = "var(--orange-400)";
export const supplierBackgroundColor = "var(--beige-100)";
export const headerColor = "var(--gold-400)"; // #e9e9e9
export const tyreWheelClasses = ["02", "03"];
export const orderStatusList = ["未発注", "確認中", "発注待ち", "発注済", "出荷済", "入荷待ち", "", "", "", "欠品",...Array(90), "本部未発注", "本部確認済"] as const; // 0:未発注/1:確認中/2:発注待ち/3:発注済（出荷待ち）/4:出荷済/5:入荷待ち/9:欠品/100:本部未発注
export const orderStatusNumberApiList = [0, 1, 2, 3, 4, 5, 9, 100, 101] as const; // orderStatusList[number]に対応。
export const orderStatusOptionList = ["", "未発注", "確認中", "発注待ち", "発注済", "出荷済", "入荷待ち", "欠品", "本部未発注", "本部確認済"] as const; // orderStatusListをoptionListとして表示する
export const orderReceiptStatusList = ["", "発注済", "出荷済", "入荷待ち", "欠品"] as const;
export const shippingStatusList = ["", "出荷", "入荷待ち", "欠品"] as const;
export const storehouseSupplierOptions = ["倉庫", "仕入先"] as const; // 倉庫、仕入先の選択肢として使用する
export const hasRepresentativeCd = ["全て", "代表コード有りのみ", "代表コード無しのみ"] as const;
export const productTypeOptions = ["一般用品", "タイヤ・ホイール"] as const;
export const tyreWheelRepresentativeSearchOptions = ["タイヤ", "ホイール", "代表コード"] as const; // 商品コード検索、タイヤ・ホイール検索オプション
export const generalRepresentativeSearchOptions = ["A・V・C","エンジンオイル","四輪車バッテリー","手入れ・洗車・ケミカル","車内用品","車外用品","機能用品","代表コード"] as const; // 商品コード検索、一般用品検索オプション
export const classificationNameList = ["","工賃","タイヤ", "ホイール","A・V・C","エンジンオイル","四輪車バッテリー","手入れ・洗車・ケミカル","車内用品","車外用品","機能用品"] as const;
export const requestDirectDeliveryOptions = ["物流経由で納品を希望", "メーカー直送で納品を希望", ""]; // 直送希望
export const directDeliveryOptions = ["物流経由で納品", "メーカー直送で納品", ""]; // 直送希望
export const YHClientOptions = ["YH店舗", "得意先"];
export const INT_MAX = 2 ** 31 - 1; // MySQL int型マックス値(マイナスも可の場合)
export const INVALID_DATE = 'Invalid Date'; // dayjsで不自然な日付だった場合に返却される値
export const localEnv = false; // ローカルで注文を動かす

export const RECEIVE_MODE: { [key: string]: 0 | 1 | 2 | 9 } = {
  notDownloaded: 0,
  downloaded: 1,
  shipped: 2,
  all: 9,
};

export const prefectures = [
  "全選択",
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];
